export const links = {
    fundDetail: {
        url: '/sparing-og-pensjon/fond/kjop#/kjopFond',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlua3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvYXBwcy9mdW5kLWxpc3QvY29uZmlnL2xpbmtzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1BLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBVTtJQUN4QixVQUFVLEVBQUU7UUFDUixHQUFHLEVBQUUseUNBQXlDO0tBQ2pEO0NBQ0osQ0FBQyJ9